import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { taskBulkAssingSchema } from "@backend/src/schemas/taskSchema";

type AssingUserToMultiTaskResponseType = ResponseType<null>;

function useAssingUserToMultiTaskMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<AssingUserToMultiTaskResponseType>["response"],
    AxiosResponseAndError<AssingUserToMultiTaskResponseType>["error"],
    {
      assignedToUserId: string;
      data: z.infer<typeof taskBulkAssingSchema>;
    }
  >({
    mutationFn: (data) =>
      ApiRequest.post<AssingUserToMultiTaskResponseType>(
        `${requestURLs.taskMember}bulk-assign/${data.assignedToUserId}`,
        data.data
      ),
  });

  return mutation;
}

export default useAssingUserToMultiTaskMutation;
